import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { PlazaProfitPage } from './plaza-profit';

@NgModule({
  declarations: [
    PlazaProfitPage,
  ],
  imports: [
    IonicPageModule.forChild(PlazaProfitPage),
    TranslateModule.forChild()
  ],
})
export class PlazaProfitPageModule {}



// WEBPACK FOOTER //
// ./src/pages/plaza-profit/plaza-profit.module.ts